export function isGoogleMapsUrl(location: string | null | undefined): boolean {
  if (!location?.trim()) return false;
  const s = location.trim();
  return s.startsWith("http") && (s.includes("google.com/maps") || s.includes("goo.gl/maps"));
}

export function isUrl(value: string | null | undefined): boolean {
  if (!value?.trim()) return false;
  const s = value.trim();
  return s.startsWith("http://") || s.startsWith("https://");
}

export function getMapEmbedUrl(url: string | null | undefined): string | null {
  if (!url?.trim()) return null;

  const trimmed = url.trim();

  if (trimmed.includes("/embed") || trimmed.includes("embed?")) {
    return trimmed;
  }

  // Short links set X-Frame-Options: sameorigin and cannot be embedded
  if (trimmed.includes("goo.gl/maps") || trimmed.includes("maps.app.goo.gl")) {
    return null;
  }

  if (!trimmed.includes("google.com/maps")) {
    return null;
  }

  try {
    const parsed = new URL(trimmed);

    const atMatch = parsed.pathname.match(/@(-?\d+\.?\d*),(-?\d+\.?\d*)/);
    if (atMatch?.[1] && atMatch?.[2]) {
      return `https://www.google.com/maps?q=${atMatch[1]},${atMatch[2]}&output=embed`;
    }

    const q = parsed.searchParams.get("q");
    if (q) {
      const embedUrl = new URL("https://www.google.com/maps");
      embedUrl.searchParams.set("q", q);
      embedUrl.searchParams.set("output", "embed");
      return embedUrl.toString();
    }

    const placeMatch = parsed.pathname.match(/\/place\/([^/]+)/);
    if (placeMatch?.[1]) {
      const placeName = decodeURIComponent(placeMatch[1].replace(/\+/g, " "));
      return `https://www.google.com/maps?q=${encodeURIComponent(placeName)}&output=embed`;
    }

    const sep = trimmed.includes("?") ? "&" : "?";
    return `${trimmed}${sep}output=embed`;
  } catch {
    return null;
  }
}
